import isHtmlElement from '@insight/toolkit-utils/lib/types/environment/isHtmlElement';
import { setRef } from '../utils';

const convertBasicTypeToNode = (type, env) => {
  if (!env.isInBrowser) {
    return false;
  }
  if (typeof type === 'function') {
    return type(env);
  }
  if (isHtmlElement(type)) {
    return type;
  }
  return false;
};

export const getPortalNode = (type, env, portalRef) => {
  const node = (() => {
    const test = convertBasicTypeToNode(type, env);
    if (test) return test;
    if (typeof type === 'string') return document.createElement(type);
    return null;
  })();

  if (portalRef) portalRef(node);
  return node;
};

export const getMountNode = (mountNode, env) => {
  const node = convertBasicTypeToNode(mountNode, env);
  if (node) return node;

  if (typeof mountNode === 'string') {
    const getter = mountNode.startsWith('#')
      ? document.getElementById
      : document.querySelector;
    const domNode = getter(mountNode);
    if (domNode) return domNode;
  }

  return document.body;
};
